import moment, { Duration, Moment } from 'moment';

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'interval' })
export class IntervalPipe implements PipeTransform {
  public transform(
    duration: Duration,
    {
      format = 'HH:mm:ss',
      roundTo = null,
      round24Hours = false,
    }: {
      format?: string;
      roundTo?: moment.unitOfTime.Base;
      round24Hours?: boolean;
    } = {},
  ): string {
    const epoch: Moment = moment.utc(0);
    const rawMoment: Moment = moment.utc(duration.asMilliseconds());
    const roundedMoment: Moment = roundTo ? this.roundMoment(rawMoment, roundTo) : rawMoment.clone();

    const years: number = roundedMoment.diff(epoch, 'years');
    if (format.match(new RegExp('(?<!\\\\)Y'))) {
      roundedMoment.subtract(years, 'years');
    }
    const months: number = roundedMoment.diff(epoch, 'months');
    if (format.match(new RegExp('(?<!\\\\)M'))) {
      roundedMoment.subtract(months, 'months');
    }
    const days: number = roundedMoment.diff(epoch, 'days');
    if (format.match(new RegExp('(?<!\\\\)D'))) {
      roundedMoment.subtract(days, 'days');
    }
    const hours: number = roundedMoment.diff(epoch, 'hours');
    if (format.match(new RegExp('(?<!\\\\)H'))) {
      roundedMoment.subtract(hours, 'hours');
    }
    const minutes: number = roundedMoment.diff(epoch, 'minutes');
    if (format.match(new RegExp('(?<!\\\\)m'))) {
      roundedMoment.subtract(minutes, 'minutes');
    }
    const seconds: number = roundedMoment.diff(epoch, 'seconds');
    if (format.match(new RegExp('(?<!\\\\)s'))) {
      roundedMoment.subtract(seconds, 'seconds');
    }
    const milliseconds: number = roundedMoment.diff(epoch, 'milliseconds');
    if (format.match(new RegExp('(?<!\\\\)S'))) {
      roundedMoment.subtract(milliseconds, 'milliseconds');
    }

    let prev = '';
    let formatted = format;
    while (prev !== formatted) {
      prev = formatted;
      formatted = formatted
        .replace(new RegExp('(?<!\\\\)YYYY'), years.toString())
        .replace(new RegExp('(?<!\\\\)YY'), years.toString())
        .replace(new RegExp('(?<!\\\\)MM'), this.padString(months.toString(), '0', 2))
        .replace(new RegExp('(?<!\\\\)M'), months.toString())
        .replace(new RegExp('(?<!\\\\)DD'), this.padString(days.toString(), '0', 2))
        .replace(new RegExp('(?<!\\\\)D'), days.toString())
        .replace(new RegExp('(?<!\\\\)HH'), this.padString(hours.toString(), '0', 2))
        .replace(new RegExp('(?<!\\\\)H'), hours.toString())
        .replace(new RegExp('(?<!\\\\)mm'), this.padString(minutes.toString(), '0', 2))
        .replace(new RegExp('(?<!\\\\)m'), minutes.toString())
        .replace(new RegExp('(?<!\\\\)ss'), this.padString(seconds.toString(), '0', 2))
        .replace(new RegExp('(?<!\\\\)s'), seconds.toString())
        .replace(new RegExp('(?<!\\\\)SSSS'), this.padString(milliseconds.toString(), '0', 4))
        .replace(new RegExp('(?<!\\\\)SSS'), this.padString(milliseconds.toString(), '0', 3))
        .replace(new RegExp('(?<!\\\\)SS'), this.padString(milliseconds.toString(), '0', 2))
        .replace(new RegExp('(?<!\\\\)S'), milliseconds.toString());
    }
    do {
      prev = formatted;
      formatted = formatted.replace(new RegExp('\\\\'), '');
    } while (prev !== formatted);

    return formatted;
  }

  private roundMoment(
    rawMoment: Moment,
    roundTo: moment.unitOfTime.Base,
  ): Moment {
    const startOf: Moment = rawMoment.clone().startOf(roundTo);
    const endOf: Moment = startOf.clone().add(1, roundTo);

    if (Math.abs(rawMoment.diff(startOf)) < Math.abs(rawMoment.diff(endOf))) {
      return startOf;
    } else {
      return endOf;
    }
  }

  private padString(
    rawString: string,
    padCharacter: string,
    length: number,
  ): string {
    let paddedString: string = rawString;
    while (paddedString.length < length) {
      paddedString = padCharacter + paddedString;
    }
    return paddedString;
  }
}
